
import { Expose } from "class-transformer";
import { Ticket } from "./tickets";
import { BusLookup } from "@core/model/bus-lookup/bus-lookup";

export class TicketSchedule{
    @Expose() id: any | undefined;
    @Expose() businessId: string | undefined;
    @Expose() ticketId: string | undefined;
    @Expose() frequencyId: string | undefined;
    @Expose() ticketScheduleDateTime: Date | undefined;
    @Expose() ticketScheduleSetting: string | undefined;
    @Expose() ticketScheduleStartDate: Date | undefined;
    @Expose() ticketScheduleEndDate: Date | undefined;
    @Expose() nextOccurrenceDate?: Date | undefined;
    @Expose() createdOn?: Date | undefined;
    @Expose() ticketScheduleStatusId: string | undefined;
    @Expose() ticketScheduleNotificationStatusId: string | undefined;
    @Expose() ticketsTemplate: Ticket | undefined;
    @Expose() frequencyLookup: BusLookup | undefined;
    @Expose() scheduleStatusLookup: BusLookup | undefined;
    @Expose() isRepeatForFuture?: boolean | undefined;
    @Expose() entryDate: string|undefined;
}

export class CreateTicketSchedule{
    @Expose() businessId: string | undefined;
    @Expose() ticketId: string | undefined;
    @Expose() frequencyId: string | undefined;
    @Expose() ticketScheduleDateTime: Date | undefined;
    @Expose() ticketScheduleSetting: string | undefined;
    @Expose() ticketScheduleStartDate: Date | undefined;
    @Expose() ticketScheduleEndDate: Date | undefined;
    @Expose() nextOccurrenceDate?: Date | undefined;
    @Expose() ticketScheduleStatusId: string | undefined;
    @Expose() ticketScheduleNotificationStatusId: string | undefined;
    @Expose() isRepeatForFuture?: boolean | undefined;
    @Expose() entryDate: string|undefined;
}

export class UpdateTicketSchedule{
    @Expose() id: string | undefined;
    @Expose() businessId: string | undefined;
    @Expose() ticketId: string | undefined;
    @Expose() frequencyId: string | undefined;
    @Expose() ticketScheduleDateTime: Date | undefined;
    @Expose() ticketScheduleSetting: string | undefined;
    @Expose() ticketScheduleStartDate: Date | undefined;
    @Expose() ticketScheduleEndDate: Date | undefined;
    @Expose() nextOccurrenceDate?: Date | undefined;
    @Expose() ticketScheduleStatusId: string | undefined;
    @Expose() ticketScheduleNotificationStatusId: string | undefined;
    @Expose() isRepeatForFuture?: boolean | undefined;
    @Expose() entryDate: string|undefined;
}

export class UpdateTicketScheduleStats{
    @Expose() id: string | undefined;
    @Expose() ticketScheduleStatusId: string | undefined;
    
}
